import React from 'react';

import {
  Pagination as MuiPagination,
  PaginationProps as MuiPaginationProps,
} from '@mui/material';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const Pagination = withCoreProps<PaginationProps>(
  ({ className, ...props }: React.PropsWithChildren<PaginationProps>) => {
    const clsxClass = clsx(className);

    return <MuiPagination {...props} className={clsxClass} />;
  },
);

export interface PaginationProps extends MuiPaginationProps, CoreProps {}
